import type { RoundConfiguration } from "Models";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";
import RoundConfigurationSettingsView from "components/control/dashboard/round-configuration-manage/RoundConfigurationSettingsView";

/**
 * Read-only view of the Round Preset a league's rounds are being seeded from,
 * opened from Season Setup.
 *
 * Picking a preset by name is a blind choice otherwise — the operator may have
 * several and no way to tell which is which without leaving the wizard. Shows
 * the same settings panel the Round Presets screen expands, so a preset reads
 * identically in both places.
 */
export function RoundPresetSheet({
  open,
  onOpenChange,
  preset,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  preset?: RoundConfiguration;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full gap-0 overflow-y-auto sm:max-w-xl"
      >
        <SheetHeader>
          <SheetTitle className="poppins font-semibold tracking-tight">
            {preset?.name ?? "Round Preset"}
          </SheetTitle>
          <SheetDescription>
            Generated rounds take this preset&rsquo;s conditions and automation.
            Course and holes stay per round, and tees come from the league.
          </SheetDescription>
        </SheetHeader>
        <div className="px-4 pb-6">
          {preset ? (
            <RoundConfigurationSettingsView
              config={preset}
              include={["Conditions", "Automation"]}
            />
          ) : (
            <p className="px-2 py-3 text-sm text-text-muted">
              No preset selected.
            </p>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
